// extracted by mini-css-extract-plugin
module.exports = {"container":"MembershipCard_container__RejEG","content":"MembershipCard_content__c2Wtv","spin":"MembershipCard_spin__4gBnd","loader":"MembershipCard_loader__Ih7rj"};